import { useDispatch } from 'react-redux';

import { configs } from '@constants/configs/configs';
import { api } from '@modules/common-utils-services/axiosUtil';
import { startSpinner, stopSpinner } from '@actions/common/actionCreators';
import { SPINNER_MESSAGES_IDS } from '@constants/common/miscellaneous';

export const useAccessCode = () => {
    const dispatch = useDispatch();

    const verifyAccessCode = async (params: string) => {
        const url = configs.endpoints.ACCESS_CODE_VERIFY;
        try {
            dispatch(startSpinner(SPINNER_MESSAGES_IDS.LOADING_DATA)); // Start spinner
            const res = await api.post(url, params);
            return res?.data;
        } catch (error) {
            if (error?.response?.status === 400) {
                return error.response.data ?? null;
            }
            console.error('Error while validating access code.:', error);
            throw new Error(error);
        } finally {
            dispatch(stopSpinner()); // Stop spinner
        }
    };

    return { verifyAccessCode };
};